import { AccountCredentials as CredentialsView } from "@softmax/product-ux/account";
import { CredentialOperation } from "./credential-operation";
import { CredentialsRegion } from "./credential-region";
import { CredentialPlayerList } from "./credential-player-list";
import { PlayerOperation } from "./player-operation";
import { usePlayerCredentials } from "./use-player-credentials";

export function AccountCredentials() {
  const {
    query,
    error,
    unavailable,
    busy,
    credentialIntent,
    setCredentialIntent,
    playerIntent,
    setPlayerIntent,
    finalFocusRef,
    refreshPlayers,
    openCredential,
    openPlayer,
  } = usePlayerCredentials();
  return (
    <>
      <CredentialsView
        userCredentials={
          <CredentialsRegion
            target={{ kind: "user" }}
            onOpen={openCredential}
          />
        }
        playersRefreshing={busy || query.isLoading}
        onCreatePlayer={() => void openPlayer({ kind: "create" })}
        players={
          <CredentialPlayerList
            players={query.data}
            ready={query.isReady}
            unavailable={unavailable}
            error={error}
            refreshing={busy}
            onCredential={openCredential}
            onRename={(player) => void openPlayer({ kind: "rename", player })}
            onRefresh={refreshPlayers}
          />
        }
      />
      {!unavailable && (
        <>
          {credentialIntent ? (
            <CredentialOperation
              intent={credentialIntent}
              finalFocusRef={finalFocusRef}
              onClose={() => setCredentialIntent(null)}
            />
          ) : null}
          {playerIntent ? (
            <PlayerOperation
              key={
                playerIntent.kind === "create"
                  ? "create"
                  : playerIntent.player.id
              }
              intent={playerIntent}
              finalFocusRef={finalFocusRef}
              refreshing={busy}
              refreshError={error?.message}
              onRefresh={async () => {
                if (await refreshPlayers()) setPlayerIntent(null);
              }}
              onClose={() => setPlayerIntent(null)}
            />
          ) : null}
        </>
      )}
    </>
  );
}
